import AdditionalContent from '@/components/b2b/Account/AdditionalContent';
import { AccountScreenConfig } from '@/components/SimplifiedSignup/Account/types';
import { accountFAQ } from '@/components/SimplifiedSignup/Account/utils';
import { HandoffScreenConfig } from '@/components/SimplifiedSignup/Handoff/types';
import { PaymentScreenConfig } from '@/components/SimplifiedSignup/Payment/types';
import { CopyItem } from '@/components/valuePropList';
import getUrl from '@/utils/getUrl';

import { ErrorScreenConfig } from '../../Error/types';
import ControlScreenConfigs from '../Control/Screens';
import messages, { FaqMessages } from './messages';

export const valueProps: Array<CopyItem> = [
	{
		id: 'valueProp1',
		header: messages.valueProp1Head,
		body: messages.valueProp1Body,
	},
	{
		id: 'valueProp2',
		header: messages.valueProp2Head,
		body: messages.valueProp2Body,
	},
	{
		id: 'valueProp3',
		header: messages.valueProp3Head,
	},
	{
		id: 'valueProp4',
		header: messages.valueProp4Head,
	},
];

const TrueMedAccountScreenConfig: AccountScreenConfig = {
	...ControlScreenConfigs.account,
	backgroundKey: 'gray0',
	upsellBullets: valueProps,
	valuePropsButtonColor: 'blue3',
	upsellHeader: () => ({ message: messages.valuePropHeader }),
	upsellSubHeader: () => ({ message: messages.valuePropSubHeader }),
	showHeader: false,
	heading: () => ({ message: messages.loginFormHeading }),
	limitedTimeOffer: false,
	valuePropsTitleColor: 'blue7',
	isValuePropsListOrdered: true,
	AdditionalContent: () => <AdditionalContent />,
	FAQs: accountFAQ(FaqMessages, 8, {
		supportTrueMedLink: () => <a href="mailto:support@truemed.com">support@truemed.com</a>,
	}),
	nextScreen: ({ routeToScreen }) => {
		routeToScreen('payment');
	},
};

const TrueMedPaymentScreenConfig: PaymentScreenConfig = {
	...ControlScreenConfigs.payment,
	limitedTimeOffer: false,
	basicLineHeader: undefined,
	upsellBullets: valueProps,
	heading: () => ({ message: messages.valuePropHeader }),
	subHeading: { message: messages.valuePropSubHeader },
	showToggle: false,
	terms: messages.terms,
	userCanExit: false,
	showHeader: false,
	hasTrueMedSupport: true,
};

const TrueMedHandoffScreenConfig: HandoffScreenConfig = {
	...ControlScreenConfigs.handoff,
	showHeader: false,
	userCanExit: true,
	heading: undefined,
	CTA: {
		onClick: async routerPush => {
			await routerPush(`${getUrl('www-app')}`);
		},
		label: messages.handoffCTALabel,
		href: '/app',
	},
	hasTrueMedSupport: true,
};

const TrueMedErrorScreenConfig: ErrorScreenConfig = {
	...ControlScreenConfigs.error,
};

export default {
	account: TrueMedAccountScreenConfig,
	payment: TrueMedPaymentScreenConfig,
	handoff: TrueMedHandoffScreenConfig,
	error: TrueMedErrorScreenConfig,
};
